var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ReportEntityDetails__Component" },
    [
      _c("FieldInlineText", {
        attrs: { label: "אימייל", "read-only": _vm.readOnly },
        on: { onChange: _vm.onChange },
        model: {
          value: _vm.model.Email,
          callback: function($$v) {
            _vm.$set(_vm.model, "Email", $$v)
          },
          expression: "model.Email"
        }
      }),
      _c("FieldInlineText", {
        attrs: { label: "עמלת הסבה", readOnly: _vm.readOnly },
        on: { onChange: _vm.onChange },
        model: {
          value: _vm.model.Fee,
          callback: function($$v) {
            _vm.$set(_vm.model, "Fee", $$v)
          },
          expression: "model.Fee"
        }
      }),
      _c("FieldInlineSelect", {
        attrs: {
          label: "יכול לאשר דוחות לתשלום",
          filterable: false,
          clearable: false,
          options: [
            { Value: true, Text: "כן" },
            { Value: false, Text: "לא" }
          ],
          readOnly: _vm.readOnly,
          required: "true"
        },
        on: { onChange: _vm.onChange },
        model: {
          value: _vm.model.AllowsApproval,
          callback: function($$v) {
            _vm.$set(_vm.model, "AllowsApproval", $$v)
          },
          expression: "model.AllowsApproval"
        }
      }),
      _c("FieldInlineSelect", {
        attrs: {
          label: "הסבות מופסקות",
          filterable: false,
          clearable: false,
          options: [
            { Value: true, Text: "כן" },
            { Value: false, Text: "לא" }
          ],
          readOnly: _vm.readOnly,
          required: "true"
        },
        on: { onChange: _vm.onChange },
        model: {
          value: _vm.model.ForbidTransfer,
          callback: function($$v) {
            _vm.$set(_vm.model, "ForbidTransfer", $$v)
          },
          expression: "model.ForbidTransfer"
        }
      }),
      _c("FieldInlineText", {
        attrs: { label: "מספר פנימי", readOnly: _vm.readOnly },
        on: { onChange: _vm.onChange },
        model: {
          value: _vm.model.InternalClientId,
          callback: function($$v) {
            _vm.$set(_vm.model, "InternalClientId", $$v)
          },
          expression: "model.InternalClientId"
        }
      }),
      !_vm.model.IsForeignCitizen
        ? _c("FieldInlineSelect", {
            attrs: {
              "alert-not-exist": true,
              label: "עיר",
              clearable: true,
              filterable: true,
              "null-is-value": true,
              placeholder: "הקלד עיר",
              options: [],
              "fetch-options": _vm.onSearchCities,
              reduce: function(item) {
                return item
              },
              readOnly: _vm.readOnly
            },
            on: { onChange: _vm.onCityChange },
            model: {
              value: _vm.model.City,
              callback: function($$v) {
                _vm.$set(_vm.model, "City", $$v)
              },
              expression: "model.City"
            }
          })
        : _vm._e(),
      _vm.model.IsForeignCitizen
        ? _c("FieldInlineText", {
            attrs: { label: "עיר", readOnly: _vm.readOnly },
            on: { onChange: _vm.onChange },
            model: {
              value: _vm.model.City,
              callback: function($$v) {
                _vm.$set(_vm.model, "City", $$v)
              },
              expression: "model.City"
            }
          })
        : _vm._e(),
      !_vm.model.IsForeignCitizen
        ? _c("FieldInlineSelect", {
            attrs: {
              "alert-not-exist": true,
              label: "רחוב",
              clearable: true,
              filterable: true,
              "null-is-value": true,
              placeholder: "הקלד רחוב",
              options: [],
              "fetch-options": _vm.onSearchCityAddress,
              reduce: function(item) {
                return item
              },
              readOnly: _vm.readOnly || !_vm.model.City
            },
            on: { onChange: _vm.onChange },
            model: {
              value: _vm.model.Street,
              callback: function($$v) {
                _vm.$set(_vm.model, "Street", $$v)
              },
              expression: "model.Street"
            }
          })
        : _vm._e(),
      _vm.model.IsForeignCitizen
        ? _c("FieldInlineText", {
            attrs: { label: "רחוב", readOnly: _vm.readOnly },
            on: { onChange: _vm.onChange },
            model: {
              value: _vm.model.Street,
              callback: function($$v) {
                _vm.$set(_vm.model, "Street", $$v)
              },
              expression: "model.Street"
            }
          })
        : _vm._e(),
      _c("FieldInlineText", {
        attrs: { label: "מספר בית", readOnly: _vm.readOnly },
        on: { onChange: _vm.onChange },
        model: {
          value: _vm.model.HouseNumber,
          callback: function($$v) {
            _vm.$set(_vm.model, "HouseNumber", $$v)
          },
          expression: "model.HouseNumber"
        }
      }),
      _c("FieldInlineText", {
        attrs: { label: "מיקוד", readOnly: _vm.readOnly },
        on: { onChange: _vm.onChange },
        model: {
          value: _vm.model.ZipCode,
          callback: function($$v) {
            _vm.$set(_vm.model, "ZipCode", $$v)
          },
          expression: "model.ZipCode"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }